import { configureStore } from '@reduxjs/toolkit'
import marketsReducer from './markets';
import userReducer from './user';

export default configureStore({
    reducer : {
        markets : marketsReducer,
        user: userReducer
    }
});